import { AbstractControl, ValidationErrors, Validator, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { Directive, Input } from '@angular/core';
@Directive({
    selector: '[appMinValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValidator, multi: true }]
})
export class MinValidator implements Validator {
    @Input('appMinValidator') minValue: number;
    @Input('minOrEqual') minOrEqual = false;

    static getMinValidator(minValue: number, minOrEqual = false): ValidatorFn {
        return (c: AbstractControl): ValidationErrors | null => {
            if ((!minValue && minValue !== 0) || (!c.value && c.value !== 0))
                return null;

            const val = Number(c.value);
            if (isNaN(val))
                return null;

            if (minOrEqual && val <= minValue)
                return { 'minValue': true };

            if (val < minValue)
                return { 'minValue': true };

            return null;
        };
    }
    validate(c: AbstractControl): ValidationErrors {
        if ((!this.minValue && this.minValue !== 0) || (!c.value && c.value !== 0))
            return null;

        const val = Number(c.value);
        if (isNaN(val))
            return null;

        if (this.minOrEqual && val <= this.minValue)
            return { 'minValue': true };

        if (val < this.minValue)
            return { 'minValue': true };

        return null;
    }

    // registerOnValidatorChange?(fn: () => void): void {
    //     throw new Error("Method not implemented.");
    // }


}
